import { createClient } from '@supabase/supabase-js';
import { createSupabaseFetch } from './mockSupabaseFetch';

function getValidSupabaseConfig() {
  const envUrl = (process.env.REACT_APP_SUPABASE_URL || '').trim();
  const envAnon = (process.env.REACT_APP_SUPABASE_ANON_KEY || '').trim();

  let isValidUrl = false;
  if (envUrl && !envUrl.includes('<') && !envUrl.includes('>')) {
    try {
      const parsed = new URL(envUrl);
      isValidUrl = parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch {
      isValidUrl = false;
    }
  }

  const isValidAnon = Boolean(
    envAnon &&
    !envAnon.includes('<') &&
    !envAnon.includes('>') &&
    envAnon.length > 20
  );

  const fallbackUrl = 'https://placeholder-project.supabase.co';
  const fallbackAnon = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.e30.placeholder';

  if (!isValidUrl || !isValidAnon) {
    console.info('[MTSRpay] Using in-memory fallback client. All demo accounts (Bendahara, Guru, Orangtua) are ready to use.');
  }

  return {
    url: isValidUrl ? envUrl : fallbackUrl,
    anon: isValidAnon ? envAnon : fallbackAnon,
    isConfigured: isValidUrl && isValidAnon,
  };
}

export const { url: supabaseUrl, anon: supabaseAnonKey, isConfigured: isSupabaseConfigured } = getValidSupabaseConfig();

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  global: {
    fetch: createSupabaseFetch({ isConfigured: isSupabaseConfigured }),
  },
});
